export default __webpack_public_path__ + "static/media/19-prepare-an-interview.aa6def08.svg";